<template>
  <div class="selector-option-holder" :class="isSelected">{{ option }}</div>
</template>

<script>
import { usePipeStore } from '@/store/PipeStore';

export default {
  name: 'SelectorOption',
  props: [
    'option',
    'type'
  ],
  computed: {
    isSelected () {


      let css = '';
      const pipeStore = usePipeStore();

      if (pipeStore.getEditedPipe === null) {
        return;
      }

      css = (pipeStore.getEditedPipe[this.$props.type] === this.$props.option) ? 'selected' : '';
      if (pipeStore.getAllowPipeEdit) { css += ' editable'; }
      return css;
    },
    isSelectable () {
      return usePipeStore().getAllowPipeEdit;
    }
  }
};
</script>

<style scoped>
.selector-option-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  height: 25px;
  margin-left: 8px;
  border-radius: 13px;
  border: 2px solid transparent;
  background-color: whitesmoke;
  user-select: none;
  pointer-events: none;
  font-size: 80%;
  font-weight: bold;
}
.selected {
  border: 2px solid #4d4d4d;
  background-color: #e3e3e3;
}
.editable {
  cursor: pointer;
  pointer-events: auto;
}
</style>